import React from 'react';
import Categories from '../../../../../components/page/category/Categories';

export default function CategoriesVendor() {
	return (
		<>
			<Categories />
		</>
	);
}
